module.exports = __webpack_public_path__ + "img/1F1EC-1F1F9.1d80a3e5.svg";